// Ermöglicht die TOTP-Einrichtung per QR-Code oder manuellem Schlüssel auf demselben Gerät.
import React, { useState } from "react";
import { Button, LinearProgress, TextField, Typography, IconButton, Grid } from "@material-ui/core";
import { FileCopy } from "@material-ui/icons";
import QRCode from "react-qr-code";

const normalizeCode = (value) => value.replace(/\D/g, "").slice(0, 6);
const formatSecret = (secret) => (secret.match(/.{1,4}/g) || []).join(" ");

const TotpEnrollment = ({ enrollment, processing, error, onSubmit }) => {
	const [code, setCode] = useState("");
	const [copied, setCopied] = useState(false);
	const submit = () => code.length === 6 && onSubmit(code);
	const copySecret = async () => {
		if (navigator.clipboard) {
			await navigator.clipboard.writeText(enrollment.secret);
			setCopied(true);
		}
	};

	return <>
		<Typography component="h1" variant="h5" align="center">
			Authenticator einrichten
		</Typography>
		<Typography variant="body2" paragraph>
			Scanne den QR-Code mit einer beliebigen TOTP-App oder übernimm den Schlüssel manuell.
		</Typography>
		<div style={{ background: "white", padding: 16, textAlign: "center" }}>
			<QRCode value={enrollment.provisioning_uri} size={180} aria-label="TOTP QR-Code" />
		</div>
		<Typography variant="subtitle2">Manueller Schlüssel</Typography>
		<Grid container alignItems="center" justifyContent="flex-start" spacing={1}>
			<Grid item>
				<Typography variant="body2" data-testid="totp-secret" style={{ overflowWrap: "anywhere" }}>
					{formatSecret(enrollment.secret)}
				</Typography>
			</Grid>
			<Grid item>
				<IconButton size="small" onClick={copySecret}>
					<FileCopy />
				</IconButton>
			</Grid>
		</Grid>
		<TextField
			id="totp-enrollment-code"
			label="Erster Authenticator-Code"
			variant="outlined"
			margin="normal"
			fullWidth
			required
			autoComplete="one-time-code"
			inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 6 }}
			value={code}
			onChange={(event) => setCode(normalizeCode(event.target.value))}
			onKeyDown={(event) => {
				if (event.key === "Enter") {
					event.preventDefault();
					submit();
				}
			}}
			disabled={processing}
			error={Boolean(error)}
			helperText={error ? "Der Code ist ungültig oder abgelaufen." : ""}
		/>
		<Button
			variant="contained"
			color="primary"
			size="large"
			fullWidth
			disabled={processing || code.length !== 6}
			onClick={submit}
		>
			Einrichtung abschließen
		</Button>
		{processing && <LinearProgress color="secondary" />}
	</>;
};

export default TotpEnrollment;
